import { Action } from 'redux';

import { CILNotificationReplacementComponentPage } from './_components/replacement.component';

// We can use enums instead of type constants like in the example. This is a newer TS feature
export enum CILNotificationReplacementActionType {
  CheckBox = 'CILNotificationReplacementCheckBox',
  CheckDate = 'CILNotificationReplacementCheckDate',
  CheckSignature = 'CILNotificationReplacementCheckSignature',
  GotoPage = 'CILNotificationReplacementGotoPage',
  Leave = 'CILNotificationReplacementLeave'
}

// This is defining the action definition for certain actions on the page.
// There may be multiple types of these on a given page.
// All properties should be readonly.

interface CILNotificationReplacementAction extends Action {
  readonly type: CILNotificationReplacementActionType;
}

export interface CheckBoxAction extends CILNotificationReplacementAction {}
export interface CheckDateAction extends CILNotificationReplacementAction {
  readonly date: Date;
}
export interface CheckSignatureAction extends CILNotificationReplacementAction {
  readonly signature: string;
}

export interface GotoPageAction extends Action {
  readonly page: CILNotificationReplacementComponentPage;
}

export interface LeaveAction extends CILNotificationReplacementAction {}

// Actions for each action type declared here.
// They should all return an action object.
export function gotoPage(page: CILNotificationReplacementComponentPage): GotoPageAction {
  return {
    type: CILNotificationReplacementActionType.GotoPage,
    page: page
  };
}

export function checkBox(): CheckBoxAction {
  return {
    type: CILNotificationReplacementActionType.CheckBox
  };
}

export function checkDate(date: Date): CheckDateAction {
  return {
    type: CILNotificationReplacementActionType.CheckDate,
    date: date
  };
}

export function checkSignature(signature: string): CheckSignatureAction {
  return {
    type: CILNotificationReplacementActionType.CheckSignature,
    signature: signature
  };
}

export function leave(): LeaveAction {
  return {
    type: CILNotificationReplacementActionType.Leave
  };
}



// WEBPACK FOOTER //
// ./src/cil-notification/_components/replacement/replacement.actions.tsx